import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminLayout from './AdminLayout';

const Media = () => {
  const [userEmail, setUserEmail] = useState('');
  const [mediaFiles, setMediaFiles] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const email = localStorage.getItem('userEmail');
    
    if (!isLoggedIn || !email) {
      navigate('/login');
      return;
    }
    
    setUserEmail(email);
    
    // Media files d'exemple
    setMediaFiles([
      {
        id: 1,
        name: 'agriculture-innovation.jpg',
        type: 'image',
        size: '2.4 MB',
        uploadDate: '2024-01-15',
        url: 'https://via.placeholder.com/300x200/8b5cf6/ffffff?text=Image+1'
      },
      {
        id: 2,
        name: 'sustainability-report.pdf',
        type: 'document',
        size: '1.8 MB',
        uploadDate: '2024-01-14',
        url: 'https://via.placeholder.com/300x200/ef4444/ffffff?text=PDF'
      },
      {
        id: 3,
        name: 'farm-video.mp4',
        type: 'video',
        size: '15.2 MB',
        uploadDate: '2024-01-13',
        url: 'https://via.placeholder.com/300x200/10b981/ffffff?text=Video'
      }
    ]);
  }, [navigate]);

  const handleDeleteFile = (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce fichier ?')) {
      setMediaFiles(mediaFiles.filter(file => file.id !== id));
    }
  };

  const getFileIcon = (type) => {
    switch (type) {
      case 'image': return 'fas fa-image';
      case 'video': return 'fas fa-video';
      case 'document': return 'fas fa-file-pdf';
      default: return 'fas fa-file';
    }
  };

  const getFileColor = (type) => {
    switch (type) {
      case 'image': return '#8b5cf6';
      case 'video': return '#10b981';
      case 'document': return '#ef4444';
      default: return '#6b7280';
    }
  };

  return (
    <AdminLayout>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #96ca2d 0%, #7fb800 100%)',
        borderRadius: '16px',
        padding: '24px',
        marginBottom: '24px',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 8px 25px rgba(150, 202, 45, 0.2)'
      }}>
        <div style={{
          position: 'absolute',
          top: '-20%',
          right: '-10%',
          width: '200px',
          height: '200px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          zIndex: 1
        }} />
        
        <div style={{ position: 'relative', zIndex: 2 }}>
          <h1 style={{
            fontSize: 'clamp(24px, 3vw, 36px)',
            fontWeight: '800',
            margin: '0 0 8px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <i className="fas fa-images" />
            Media Management
          </h1>
          <p style={{
            fontSize: '16px',
            margin: '0 0 24px 0',
            opacity: 0.9
          }}>
            Gérez vos fichiers images, vidéos et documents
          </p>
          
          <div style={{
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap',
            alignItems: 'center'
          }}>
            <button
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '12px',
                padding: '12px 20px',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <i className="fas fa-upload" />
              Uploader un fichier
            </button>
            
            <div style={{
              background: 'rgba(255, 255, 255, 0.2)',
              padding: '8px 16px',
              borderRadius: '20px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.3)'
            }}>
              <i className="fas fa-chart-bar" style={{ marginRight: '8px' }} />
              {mediaFiles.length} fichiers au total
            </div>
          </div>
        </div>
      </div>

      {/* Media Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        {mediaFiles.map(file => (
          <div key={file.id} style={{
            background: 'white',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(150, 202, 45, 0.1)',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-4px)';
            e.target.style.boxShadow = '0 8px 30px rgba(150, 202, 45, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
          }}
          >
            {/* Preview */}
            <div style={{
              height: '200px',
              background: `url(${file.url}) center/cover`,
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <div style={{
                background: 'rgba(0, 0, 0, 0.7)',
                color: 'white',
                padding: '12px 16px',
                borderRadius: '8px',
                fontSize: '24px'
              }}>
                <i className={getFileIcon(file.type)} />
              </div>
            </div>

            {/* Content */}
            <div style={{ padding: '24px' }}>
              <h3 style={{
                fontSize: '16px',
                fontWeight: '700',
                margin: '0 0 8px 0',
                color: '#1f2937',
                lineHeight: '1.4'
              }}>
                {file.name}
              </h3>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px'
              }}>
                <span style={{
                  background: `${getFileColor(file.type)}20`,
                  color: getFileColor(file.type),
                  padding: '4px 8px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '600'
                }}>
                  {file.type.toUpperCase()}
                </span>
                <span style={{
                  fontSize: '12px',
                  color: '#9ca3af'
                }}>
                  {file.size}
                </span>
              </div>

              <div style={{
                fontSize: '12px',
                color: '#9ca3af',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <i className="fas fa-calendar" />
                Uploadé le {file.uploadDate}
              </div>

              {/* Actions */}
              <div style={{
                display: 'flex',
                gap: '8px'
              }}>
                <button
                  style={{
                    flex: 1,
                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <i className="fas fa-download" style={{ marginRight: '4px' }} />
                  Télécharger
                </button>
                <button
                  onClick={() => handleDeleteFile(file.id)}
                  style={{
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '600',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <i className="fas fa-trash" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
};

export default Media;